import { ResponsiveContainer, media } from 'app/assets/styles'
import { ErrorManagement } from 'app/common/error-management'
import { Layout } from 'app/common/layout'
import React, { Component, Fragment } from 'react'
import { getIsFromApp, getUrlParams } from 'shared/utils/ecommerce/utils'
import styled from 'styled-components'

type Props = {
    location: Object,
    content: string,
    fetchCustomPageData: string => void,
    error: ?any,
    networkError: ?any,
    match: any,
    location: any,
    dataLoaded: boolean
}

export class CustomComponent extends Component<Props> {
    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps: Props) {
        this.fetchData(prevProps)
    }

    fetchData = (prevProps?: Props) => {
        const { fetchCustomPageData, match, location } = this.props
        const { name } = match.params
        if (
            !prevProps ||
            (prevProps &&
                (location !== prevProps.location ||
                    name !== prevProps.match.params.name))
        ) {
            const { search } = location
            fetchCustomPageData(`${name}${search}`)
        }
    }

    render() {
        const { content, error, networkError, location } = this.props
        const htmlContent = content && (
            <div
                dangerouslySetInnerHTML={{
                    __html: content
                }}
            />
        )
        const params = getUrlParams(window.location.href)
        const isFromApp = getIsFromApp(params)
        return (
            <ErrorManagement error={error} networkError={networkError}>
                <Fragment>
                    {isFromApp ? (
                        <Container>{htmlContent}</Container>
                    ) : (
                        <Layout background="plain">
                            <Container id="web" className="web">
                                {htmlContent}
                            </Container>
                        </Layout>
                    )}
                </Fragment>
            </ErrorManagement>
        )
    }
}

const Container = styled(ResponsiveContainer)`
    padding-top: 0;
    ul {
        list-style-type: disc;
        list-style-position: inside;
    }
    &.web {
        padding-top: 60px;
        ${media.medium`
            padding-top: 80px;
        `};
    }
`
